"use strict";

var _defineProperty = require("/app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var UniverseLogError_1 = require("../error/UniverseLogError");

var LogLevel;

(function (LogLevel) {
  LogLevel["error"] = "error";
  LogLevel["warn"] = "warn";
  LogLevel["info"] = "info";
  LogLevel["http"] = "http";
  LogLevel["verbose"] = "verbose";
  LogLevel["debug"] = "debug";
  LogLevel["silly"] = "silly";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));

(function (LogLevel) {
  var _LogLevel$LEVELS_VALU, _LogLevel$LEVELS_BY_N;

  LogLevel.LEVELS_VALUES = (_LogLevel$LEVELS_VALU = {}, _defineProperty(_LogLevel$LEVELS_VALU, LogLevel.error, 0), _defineProperty(_LogLevel$LEVELS_VALU, LogLevel.warn, 1), _defineProperty(_LogLevel$LEVELS_VALU, LogLevel.info, 2), _defineProperty(_LogLevel$LEVELS_VALU, LogLevel.http, 3), _defineProperty(_LogLevel$LEVELS_VALU, LogLevel.verbose, 4), _defineProperty(_LogLevel$LEVELS_VALU, LogLevel.debug, 5), _defineProperty(_LogLevel$LEVELS_VALU, LogLevel.silly, 6), _LogLevel$LEVELS_VALU);
  LogLevel.LEVELS_BY_NAME = (_LogLevel$LEVELS_BY_N = {}, _defineProperty(_LogLevel$LEVELS_BY_N, LogLevel.error, LogLevel.error), _defineProperty(_LogLevel$LEVELS_BY_N, LogLevel.warn, LogLevel.warn), _defineProperty(_LogLevel$LEVELS_BY_N, LogLevel.info, LogLevel.info), _defineProperty(_LogLevel$LEVELS_BY_N, LogLevel.http, LogLevel.http), _defineProperty(_LogLevel$LEVELS_BY_N, LogLevel.verbose, LogLevel.verbose), _defineProperty(_LogLevel$LEVELS_BY_N, LogLevel.debug, LogLevel.debug), _defineProperty(_LogLevel$LEVELS_BY_N, LogLevel.silly, LogLevel.silly), _LogLevel$LEVELS_BY_N);
  LogLevel.DEFAULT_LEVEL = LogLevel.info;

  function valueOf(name) {
    if (typeof LogLevel.LEVELS_BY_NAME[name] === "undefined") {
      var availableLevels = Object.keys(LogLevel.LEVELS_BY_NAME).join(", ");
      throw new UniverseLogError_1.UniverseLogError("There is no such log level: '".concat(name, "'. Available levels: [ ").concat(availableLevels, " ]"));
    }

    return LogLevel.LEVELS_BY_NAME[name];
  }

  LogLevel.valueOf = valueOf;

  function levelToValue(name) {
    if (typeof LogLevel.LEVELS_VALUES[name] === "undefined") {
      var availableLevels = Object.keys(LogLevel.LEVELS_BY_NAME).join(", ");
      throw new UniverseLogError_1.UniverseLogError("There is no such log level: '".concat(name, "'. Available levels: [ ").concat(availableLevels, " ]"));
    }

    return LogLevel.LEVELS_VALUES[name];
  }

  LogLevel.levelToValue = levelToValue;

  function isLessOrEquallyVerbose(args) {
    return levelToValue(args.level) <= levelToValue(args.threshold);
  }

  LogLevel.isLessOrEquallyVerbose = isLessOrEquallyVerbose;

  function moreVerbose(a, b) {
    return LogLevel.LEVELS_VALUES[a] > LogLevel.LEVELS_VALUES[b] ? a : b;
  }

  LogLevel.moreVerbose = moreVerbose;

  function lessVerbose(a, b) {
    return LogLevel.LEVELS_VALUES[a] < LogLevel.LEVELS_VALUES[b] ? a : b;
  }

  LogLevel.lessVerbose = lessVerbose;
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));